/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignClientToAppointmentRequest
 */
export interface AssignClientToAppointmentRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignClientToAppointmentRequest
     */
    clientId: string;
}

/**
 * Check if a given object implements the AssignClientToAppointmentRequest interface.
 */
export function instanceOfAssignClientToAppointmentRequest(value: object): value is AssignClientToAppointmentRequest {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function AssignClientToAppointmentRequestFromJSON(json: any): AssignClientToAppointmentRequest {
    return AssignClientToAppointmentRequestFromJSONTyped(json, false);
}

export function AssignClientToAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignClientToAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
    };
}

export function AssignClientToAppointmentRequestToJSON(json: any): AssignClientToAppointmentRequest {
    return AssignClientToAppointmentRequestToJSONTyped(json, false);
}

export function AssignClientToAppointmentRequestToJSONTyped(value?: AssignClientToAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
    };
}

